import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import ParkDetails from "../components/MyCart/ParkDetails";
import ProductDetails from "../components/MyCart/ProductDetails";
import AddPromoCode from "../components/MyCart/AddPromoCode";
import GrandTotal from "../components/MyCart/GrandTotal";
import CartBanner from "../components/MyCart/BannerCart";
import MyCartFooter from "../components/MyCart/Footer";
import { Colors } from "../ColorConstants";
import { checkoutCart, getCart, updateCart } from "../services/cartServices";
import { getFormattedCart } from "../helper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Footer, { FooterMobile } from "../components/Footer";
import CheckoutPopup from "../components/MyCart/checkoutPopup";
import { updateGuest } from "../services/guestServices";
import ReactModal from "react-modal";
import Button from "../components/Buttons";
import CustomLoader from "../components/Loader";
import { BackArrow, BackButton } from "../assets/icons";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
import CartModal from "../components/MyCart/CartModal";
import ReactGA from "react-ga4";
import { PAYMENT_TYPE } from "../constants";
import ProductDetailsMobile from "../components/MyCart/ProductDetailsMobile";
import { Text } from "../TextConstants";
import AddPromoCodeMobile from "../components/MyCart/AddPromoCodeMobile";
import GrandTotalMobile from "../components/MyCart/GrandTotalMobile";

const MyCart = () => {
  const [promo, setPromo] = useState("");
  const [hasPromo, setHasPromo] = useState("");
  const [cart, setCart] = useState({});
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const [checkoutCustomModal, setCheckoutCustomModal] = useState(false);
  const [type, setType] = useState("");
  const [warningModal, setWarningModal] = useState(false);
  const [zeroAmtModal, setZeroAmtModal] = useState(false);
  const [insertId, setInsertId] = useState();
  const [isHavePromo, setIsHavePromo] = useState(true);
  const [isPlaceholder, setIsPlaceholder] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  let [searchParams] = useSearchParams();
  let spinpromo = searchParams.get("spinpromo");

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Cart Page" });
  }, []);

  const customStyles = {
    content: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      left: "0",
      top: 0,
      background: "transparent",
      border: "none",
      boxSizing: "border-box",
    },
    overlay: {
      background: Colors.blackOpacity,
      zIndex: 9999,
      display: "flex",
    },
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCart(spinpromo ? "applyCoupon" : "");
    if (spinpromo !== null) {
      setPromo(spinpromo);
    }
  }, [spinpromo]);

  useEffect(() => {
    const type = localStorage.getItem("type");
    if (type) {
      setType(type);
    }
  }, []);

  const fetchCart = async (from) => {
    setLoading(true);
    try {
      let res = await getCart(
        from === "deletePromo" ? "" : spinpromo || promo || ""
      );
      if (res?.data?.data?.items) {
        if (from === "applyCoupon") {
          if (res?.data?.data?.validPromo) {
            toast.success("Promo applied successfully", {
              hideProgressBar: true,
            });
            setHasPromo(true);
            setIsPlaceholder(true);
            setIsRemove(true);
          } else {
            setIsPlaceholder(false);
            setIsRemove(false);
            toast.error("Invalid Promo", { hideProgressBar: true });
          }
        }
        setCart(res?.data?.data);
        setItems(res?.data?.data?.items);
      } else {
        navigate(`/auth/home`);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    let itemsArray = [...items];
    let itemsArrayClone = JSON.parse(JSON.stringify(items));
    let index = itemsArray.findIndex((x) => x._id === id);
    itemsArray.splice(index, 1);
    setItems(itemsArray);
    try {
      let res = await updateCart(getFormattedCart(cart, itemsArray));
      fetchCart();
      console.log(res);
    } catch (err) {
      toast.error(err?.message);
      setItems(itemsArrayClone);
    }
  };
  const handleSubtract = async (id) => {
    let itemsArray = [...items];
    let itemsArrayClone = JSON.parse(JSON.stringify(items));
    let index = itemsArray.findIndex((x) => x._id === id);
    itemsArray[index].qty = itemsArray[index].qty - 1;
    if (itemsArray[index].qty === 0) {
      itemsArray.splice(index, 1);
    }
    setItems(itemsArray);
    try {
      let res = await updateCart(getFormattedCart(cart, itemsArray));
      fetchCart();
      console.log(res);
    } catch (err) {
      toast.error(err?.message);
      setItems(itemsArrayClone);
    }
  };
  const handleAdd = async (id) => {
    let itemsArray = [...items];
    let itemsArrayClone = JSON.parse(JSON.stringify(items));
    let index = itemsArray.findIndex((x) => x._id === id);
    itemsArray[index].qty = itemsArray[index].qty + 1;
    setItems(itemsArray);
    try {
      let res = await updateCart(getFormattedCart(cart, itemsArray));
      fetchCart();
    } catch (err) {
      toast.error(err?.message);
      setItems(itemsArrayClone);
    }
  };

  const handleApply = () => {
    fetchCart("applyCoupon");
  };
  const handleRemove = async () => {
    setIsPlaceholder(false);
    try {
      setPromo("");
      fetchCart("deletePromo");
    } catch (err) {
      console.log(err);
    }
  };

  const handleCheckout = async (checkoutCustomModal) => {
    const isUAT =
      window.location.hostname.includes("uat") ||
      window.location.hostname.includes("localhost");
    let dependentProducts = items
      ?.filter((item) => item.isDependent)
      .map((item) => item.dependentProduct);
    let count = 0;
    dependentProducts.forEach((item) =>
      items?.filter((cartItem) => {
        console.log(cartItem?.productId, item);
        console.log();
        cartItem.productId === item && ++count;
      })
    );

    if (dependentProducts.length !== count) {
      setWarningModal(true);
    } else {
      if (!isUAT) {
        ReactGA.event({
          category: "Custom Events",
          action: `${cart?.outletName} checkout `,
          label: `${cart?.outletName} checkout of ${type}`,
        });
      }
      if (type === "guest") {
        setCheckoutCustomModal(checkoutCustomModal);
      } else {
        if (cart?.finalAmount === 0) {
          try {
            const obj = {
              type: "wallet",
            };
            let res = await checkoutCart(cart?._id, obj);
            setInsertId(res?.data?.data?.insertId);
            if (res?.data?.status === "success") {
              setZeroAmtModal(!zeroAmtModal);
            }
          } catch (err) {
            toast.error(err?.message, { hideProgressBar: true });
          }
        } else {
          if (hasPromo) {
            navigate(`/app/checkout?promo=${promo || spinpromo}`);
            if (!isUAT) {
              ReactGA.event({
                category: "Custom Events",
                action: `${promo || spinpromo} Promo used in ${
                  cart?.outletName
                } Checkout`,
                label: `${promo || spinpromo} Promo used in ${
                  cart?.outletName
                } Checkout of ${type}`,
              });
            }
          } else {
            navigate(`/app/checkout`);
          }
        }
      }
    }
  };

  const closeTicketModal = () => {
    setZeroAmtModal(false);
  };

  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      {
        label: "Booking",
        path:
          cart?.outletShortName === "aqua_zone"
            ? `/app/aqua`
            : `/app/booking/${cart?.outletId}`,
      },
      {
        label: cart?.outletName,
        path:
          cart?.outletShortName === "aqua_zone"
            ? `/app/aqua`
            : `/app/booking/${cart?.outletId}`,
      },
      { label: "Cart", path: `/app/cart` },
    ];
  };

  const handleGuestSubmit = async (data) => {
    try {
      let res = await updateGuest(data);
      console.log(res);
      localStorage.setItem("token", res?.data?.data?.token);
      localStorage.setItem("type", res?.data?.data?.type);
      navigate(`/app/checkout?promo=${promo}`);
    } catch (err) {
      if (err?.code === 409) {
        localStorage.setItem("cartId", cart?._id);
        toast.warn("This email already exist, Please Sign In or Sign Up");
      } else {
        toast.error(err?.message);
      }
    }
  };

  return (
    <>
      {!spinpromo && (
        <BackImageContainer
          onClick={() => navigate(`/app/booking/${cart?.outletId}`)}
        >
          <BackImage src={BackButton} />
        </BackImageContainer>
      )}
      {checkoutCustomModal ? (
        <CheckoutPopup
          onClose={() => setCheckoutCustomModal(false)}
          onSubmit={handleGuestSubmit}
          cartId={cart?._id}
        />
      ) : (
        <CartContainer>
          <WebView checkoutCustomModal={checkoutCustomModal}>
            <CartBanner />
            <BreadCrumb
              items={getBreadCrumbData()}
              activeItem={"Cart"}
              isButton={false}
            />
            <ParkDetails data={cart} />
            <ProductDetails
              hasSpinPromo={spinpromo}
              data={items}
              cartData={cart}
              onDelete={handleDelete}
              onSubtract={handleSubtract}
              onAdd={handleAdd}
              isAqua={cart?.outletShortName === "aqua_zone"}
              onContinueShopping={() =>
                cart?.outletShortName === "aqua_zone"
                  ? navigate(`/app/aqua`)
                  : navigate(`/app/booking/${cart?.outletId}`)
              }
            />
            <ProductDetailsMobile
              data={items}
              onDelete={handleDelete}
              onSubtract={handleSubtract}
              onAdd={handleAdd}
              hasSpinPromo={spinpromo}
              isAqua={cart?.outletShortName === "aqua_zone"}
              onContinueShopping={() =>
                cart?.outletShortName === "aqua_zone"
                  ? navigate(`/app/aqua`)
                  : navigate(`/app/booking/${cart?.outletId}`)
              }
            />
            <PromoCodeContainerMobile>
              {isHavePromo && spinpromo == null && (
                <IsPromoQuestion onClick={() => setIsHavePromo(false)}>
                  {Text.isPromoQuestion}
                </IsPromoQuestion>
              )}
              {(!isHavePromo || hasPromo) && (
                <AddPromoCodeMobile
                  onChange={(e) => setPromo(e.target.value)}
                  value={promo}
                  spinpromo={spinpromo}
                  onApply={handleApply}
                  isPlaceholder={isPlaceholder}
                  isRemove={isRemove}
                  setIsRemove={setIsRemove}
                  onRemove={handleRemove}
                  cart={cart}
                  userType={type}
                  onContinueShopping={() =>
                    navigate(`/app/booking/${cart?.outletId}`)
                  }
                />
              )}
              <GrandTotalMobile
                data={items}
                cart={cart}
                onCheckout={handleCheckout}
              />
            </PromoCodeContainerMobile>

            <PromoTotalContainer>
              <AddPromoCode
                onChange={(e) => setPromo(e.target.value)}
                value={promo}
                spinpromo={spinpromo}
                onApply={handleApply}
                cart={cart}
                userType={type}
                onContinueShopping={() =>
                  navigate(`/app/booking/${cart?.outletId}`)
                }
              />
              <GrandTotal
                data={items}
                cart={cart}
                onCheckout={handleCheckout}
              />
            </PromoTotalContainer>
            <FooterContainer>
              <Footer />
            </FooterContainer>
            <FooterMobile />
          </WebView>
          {loading ? <CustomLoader /> : <></>}
        </CartContainer>
      )}
      <ReactModal isOpen={warningModal} style={customStyles}>
        <WarningModal>
          <WarningModalHeader>Attention!</WarningModalHeader>
          <WarningModalDescription>
            Kids under 6 years must be accompanied by an adult
          </WarningModalDescription>
          <WarningModalAction>
            <Button
              onClick={() => setWarningModal(false)}
              variant="filled"
              label={"Ok, I Understand"}
              width="15rem"
            />
          </WarningModalAction>
        </WarningModal>
      </ReactModal>
      <CartModal
        isCancelTicket={zeroAmtModal}
        closeTicketModal={closeTicketModal}
        navigate={navigate}
        insertId={insertId}
      />
    </>
  );
};
const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;

const WarningModal = styled.div`
  background: white;
  width: fit-content;
  padding: 2rem 1rem 1rem 1rem;
  border-radius: 0.5rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  @media only screen and (max-width: 640px) {
    width: 85%;
  }
`;
const WarningModalHeader = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;
const WarningModalDescription = styled.div``;
const WarningModalAction = styled.div`
  display: flex;
  justify-content: center;
`;

const CartContainer = styled.div`
  position: relative;

  @media only screen and (max-width: 640px) {
    height: 100vh;
    width: 100vw;
  }
`;
const WebView = styled.div`
  display: block;
  @media only screen and (max-width: 640px) {
    /* display:none; */
    display: ${(props) =>
      props.checkoutCustomModal === true ? "none" : "block"};
  }
`;

const PromoTotalContainer = styled.div`
  background: ${Colors.lightWhiteSmoke};
  display: flex;
  margin-top: 10rem;
  flex-direction: row;
  justify-content: space-around;
  padding: 0rem 1rem;
  gap: 1rem;
  @media only screen and (max-width: 640px) {
    flex-direction: column;
    align-items: center;
    justify-content: none;
    padding-bottom: 2rem;
    margin-top: 0rem;
  }
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const PromoCodeContainerMobile = styled.div`
  display: none;
  @media only screen and (max-width: 576px) {
    background: ${Colors.lightWhiteSmoke};
    display: flex;
    margin-top: 1.5rem;
    padding: 1.5rem 0;
    padding-bottom: 0;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
  }
`;
const IsPromoQuestion = styled.span`
  @media only screen and (max-width: 576px) {
    color: ${Colors.aqua};
    font-size: 1rem;
    font-weight: 700;
    width: 90%;
    padding-left: 1rem;
    // border: 1px solid red;
  }
`;
const PromoCodeTitle = styled.span`
  @media only screen and (max-width: 576px) {
    color: ${Colors.secondaryBlack};
    font-size: 1rem;
    font-weight: 700;
    width: 90%;
    // border: 1px solid red;
  }
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

export default MyCart;
